import Consts from '@/common/consts'
export default {
  HOT_SEARCH: `${Consts.API_HOST_MAIN}/adPdd/qryHotKw`, // 热门搜索
  SEARCH: `${Consts.API_HOST_MAIN}/adPdd/searchGoodsBykw`, // 搜索
  SEARCH_KW_CATE_GOODS: `${Consts.API_HOST_MAIN}/adPdd/querySecKwGoods`, // 搜索关键字分类商品
  
  TAB_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryTab`, // tab菜单
  TAB_SLIDE_LIST: `${Consts.API_HOST_MAIN}/adPdd/qrySlide`, // tab菜单对应的轮播
  TAB_CATE_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryCate`, // tab菜单对应的分类
  TAB_CATE_ALL_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryCateAll`, // tab菜单对应的完整分类
  SUB_CATE_LIST: `${Consts.API_HOST_MAIN}/adPdd/qrySubCate`, // 三级分类列表

  TAB_GOODS_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryTabGoods`, // tab菜单对应的商品列表
  SLIDE_GOODS_LIST: `${Consts.API_HOST_MAIN}/adPdd/qrySlideGoods`, // 轮播图对应的商品列表
  CATE_GOODS_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryCateGoods`, // 分类对应的商品列表

  GOODS_DETAIL: `${Consts.API_HOST_MAIN}/adPdd/qryAdGoodsDetail`, // 商品详情
  GOODS_DETAIL_BUY_URL: `${Consts.API_HOST_MAIN}/adPdd/qryGoodsBuyUrl`, // 查询商品购买url

  BEAN_BALANCE: `${Consts.API_HOST_MAIN}/adPdd/qryGoldenBeans`, // 金豆合计
  BEAN_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryGoldenBeansList`, // 金豆列表
  SETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adPdd/qryCommissionEnrolled`, // 已结算收益合计
  SETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryCommissionEnrolledList`, // 已结算收益列表
  UNSETTLED_PROFIT_BALANCE: `${Consts.API_HOST_MAIN}/adPdd/qryCommissionUnbooked`, // 待结算收益合计
  UNSETTLED_PROFIT_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryCommissionUnbookedList`, // 待结算收益列表
  
  ORDER_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryOrders`, // 我的订单
  TEAM_ORDER_LIST: `${Consts.API_HOST_MAIN}/adPdd/qryTeamOrders`, // 团队订单
}
